import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import Loading from '../../Shared/components/Loading/Loading'
import './PreviewModal.scoped.scss'
import useEmailPreview from 'Shared/hooks/useEmailPreview'
import EmailPreview from 'Shared/components/EmailPreview'
import EmailContentTabs from 'CampaignBuilder/components/Steps/EmailContentTabs'
import EntitySelector from 'Shared/components/EntitySelector/EntitySelector'
import MobileDesktopToggle from 'Shared/components/MobileDesktopToggle/MobileDesktopToggle'

const PreviewModal = ({ open, hide }) => {
  const act = useAct()
  const { emailBlast = {}, search = {} } = useSel(s => s.campaign)
  const { emailSender = {} } = emailBlast
  const { senderName } = emailSender
  const { id: searchId, name: searchName } = search
  const contentVariantId = useSel(s => s.local.currentContentVariantId)
  const [previewBody, previewSubjectLine, previewLoading] = useEmailPreview([open], null, null, contentVariantId)
  const { previewTargetId, renderedBody, renderedSubjectLine } = useSel((s) => s.campaignBuilder)
  
  const displayLoading = () => {
    return previewTargetId ? renderedBody === null : previewLoading
  }
  
  const [displayMode, setDisplayMode] = useState('desktop')
  
  const titleContents = <>
    <MobileDesktopToggle value={displayMode} onChange={(value) => {setDisplayMode(value);}} />
  </>

  return (
    <BackdropModal title="Email preview" open={open} onCancel={hide} tall scrollable={true} maxWidth="lg" titleContents={titleContents}>
      <EmailContentTabs />
      <div className="main">
        <div className="row">
            <div className="column entity-selector">
              <EntitySelector
                entity="target"
                scope={searchId}
                value={previewTargetId}
                onChange={(id) => act.campaignBuilder.upsert({ previewTargetId: id })}
                placeholder="Start typing a target's name"
                defaultSearch=""
                allowUnclick={true}
              />
            </div>
            <div className="column email-preview">
              {!displayLoading && <Loading text="Loading preview" />}
              {open && displayLoading && 
              <EmailPreview html={previewTargetId ? renderedBody : previewBody}
                subjectLine={previewTargetId ? renderedSubjectLine : previewSubjectLine}
                senderName={senderName}
                searchName={searchName}
                maxHeight={false}
                autoHeight={true}
                fromPreview={true}
                displayMode={displayMode}/>
              }
            </div>
          </div>
      </div>
    </BackdropModal>
  )
}

export default PreviewModal
